import { useState } from "react";
import SocialMediaIcon from "../SocialMediaIcon";
import ConnectWalletButton from "../ConnectWalletButton";

interface NavbarObjectProps {
  title: string;
  link: string;
  download?: string;
}

const Navbar = () => {
  const [isMobileNavbarOpen, setIsMobileNavbarOpen] = useState<boolean>(false);

  const navBarOptions: NavbarObjectProps[] = [
    {
      title: "About",
      link: "#about",
    },
    {
      title: "Roadmap",
      link: "#roadmap",
    },
    {
      title: "how to buy",
      link: "#howtobuy",
    },
    {
      title: "Whitepaper",
      link: "/assets/documents/PepeCoinV2-.pdf",
      download: "PEPE3D.pdf",
    },
    {
      title: "tokenomics",
      link: "#tokenomics",
    },
    {
      title: "FAQ",
      link: "#faq",
    },
  ];

  const handleScroller = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const id = target.getAttribute("data-href");
    if (!id) return;
    const element = document.querySelector(id);
    element?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <nav className="fixed top-0 left-0 z-[99999] bg-gradient-to-b from-[#0000009b] to-transparent text-white w-full">
      <div className=" mx-auto lg:flex items-center justify-around w-full gap-6 px-4 ">
        <div className="flex items-center justify-between md:w-auto w-full">
          <a
            onClick={handleScroller}
            data-href="#main"
            className="flex py-5 px-2 text-2xl font-extrabold uppercase tracking-wide text-white bg-gradient-to-r from-green-300 to-green-600 custom-text hover:cursor-pointer "
          >
            <img
              data-href="#main"
              className="hover:cursor-pointer"
              width={64}
              height={64}
              src={"/assets/images/logo.png"}
            />
          </a>

          <ButtonAndSocials className=" flex lg:hidden" />

          <div className="lg:hidden flex items-center">
            <button
              type="button"
              className="mobile-menu-button"
              onClick={() =>
                setIsMobileNavbarOpen((currentState) => !currentState)
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                />
              </svg>
            </button>
          </div>
        </div>

        <div
          className={` ${
            !isMobileNavbarOpen && "hidden"
          } lg:flex lg:flex-row flex-col items-center justify-center text-center md:space-x-1 pb-3 md:pb-0 navigation-menu bg-[#000000ab] rounded-lg  md:bg-transparent `}
        >
          {navBarOptions.map(({ title, link, download }, index) =>
            title !== "Whitepaper" ? (
              <a
                onClick={handleScroller}
                key={`navbar-option-${index}`}
                data-href={link}
                className="block hover:cursor-pointer text-white tracking-wider uppercase font-bold hover:bg-green-500 hover:text-white rounded-md px-3 py-2 text-sm sm:text-  transition"
              >
                {title}
              </a>
            ) : (
              <a
                key={`navbar-option-${index}`}
                href={link}
                download={download}
                className="block hover:cursor-pointer text-white tracking-wider uppercase font-bold hover:bg-green-500 hover:text-white rounded-md px-3 py-2 text-sm  transition"
              >
                {title}
              </a>
            )
          )}
        </div>
        <ButtonAndSocials className=" hidden lg:flex " />
      </div>
    </nav>
  );
};

const ButtonAndSocials = ({ className }: { className?: string }) => {
  return (
    <div className={`gap-2 ${className}`}>
      <div className=" flex gap-2">
        <SocialMediaIcon
          url="https://x.com/peppecoinv2"
          imgSrc="/assets/icons/twitter.svg"
          imgAltText="Twitter_logo"
        />
        <SocialMediaIcon
          url="https://t.me/peppecoinV2"
          imgSrc="/assets/icons/telegram.svg"
          imgAltText="Telegram_logo"
        />
      </div>
      <ConnectWalletButton />
    </div>
  );
};

export default Navbar;
